const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Load isolated Parffragrance quiz discovery, attribution and recommendation fixes from the same theme CDN. */
(() => {
  const current = document.currentScript?.src;
  if (!current) return;

  const loadAsset = (filename) => {
    try {
      const url = new URL(current);
      url.pathname = url.pathname.replace(/constants\.js$/, filename);
      url.search = '';
      const script = document.createElement('script');
      script.src = url.href;
      script.async = false;
      script.dataset.parfQuizLayer = filename;
      document.head.appendChild(script);
    } catch (error) {
      console.debug(`[Parffragrance Quiz] ${filename} could not be loaded.`, error);
    }
  };

  loadAsset('parf-quiz-image-fix.js');
  loadAsset('parf-quiz-multiselect-fix.js');
  loadAsset('parf-quiz-marketing.js');
  loadAsset('parf-quiz-assisted.js');
  loadAsset('parf-cart-drawer-fix.js');
})();
